export class AddNotice {
  noticesId?: number;
  noticesDescription: string;
  noticesTitle: string;
  userTypeIds: number[];
  public constructor() {
    this.userTypeIds = [];
  }
}
